import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n
  .use(initReactI18next)
  .init({
    fallbackLng: 'vi',
    debug: false,
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    // Chấp nhận fallback content trong code nếu không tìm thấy resource
    parseMissingKeyHandler: (key, defaultValue) => defaultValue || key,
  });

export default i18n;
